import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Formik, Form, Field } from 'formik';
import Yup from 'yup';
import SubmitButton from 'base/components/forms/SubmitButton';
import FormikInputField from 'base/components/forms/formik/FormikInputField';
import FormikSelectField from 'base/components/forms/formik/FormikSelectField';
import {
  getUsersSelectOptions,
} from 'auth/store/users/selectors';


const MailingListForm = ({
  mailingList, onSubmit, userSelectOptions,
}) => (
  <Formik
    initialValues={{
      name: mailingList.name || '',
      members: mailingList.members || '',
    }}
    validationSchema={
            Yup.object().shape({
              name: Yup.string()
                .required('Name is required.'),
              members: Yup.array()
                .required('Members is required'),
            })
          }
    render={({errors, isSubmitting}) => ( // eslint-disable-line
      <Form>
        <Field
          type="text"
          name="name"
          label="Name"
          placeholder="Name"
          component={FormikInputField}
          autoFocus
        />
        <Field
          type="select"
          name="members"
          component={FormikSelectField}
          label="Members"
          options={userSelectOptions}
          isMulti
        />
        <SubmitButton type="submit" disabled={isSubmitting}>
          Save mailing list
        </SubmitButton>
      </Form>
    )}
    onSubmit={(values) => {
      const updatedMailingList = {
        ...mailingList,
        name: values.name,
        members: values.members,
      };
      onSubmit(updatedMailingList);
    }}
  />
);
MailingListForm.propTypes = {
  mailingList: PropTypes.objectOf(PropTypes.any),
  onSubmit: PropTypes.func.isRequired,
  userSelectOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
};
MailingListForm.defaultProps = {
  mailingList: {},
};

const mapStateToProps = (state) => ({
  userSelectOptions: getUsersSelectOptions(state),
});

const mapDispatchToProps = {
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MailingListForm);
